module.exports = __webpack_public_path__ + "static/media/store-feature-desktop.2c2fe441.png";